import {
  FeedbackApp,
  openFeedbackModal as newOpenFeedbackModal,
  openRequestFeedbackModal as newOpenRequestFeedbackModal
} from '@workboard/feedback-app';
import React, { createRoot } from 'react-dom/client';
import { FeedbackObjectType, LegacyFeedbackModalProps, FeedbackModalProps } from './types';

async function loadRemoteFeedbackModal(props: FeedbackModalProps) {
  try {
    // const { openFeedbackModal } = await import('FEEDBACK/feedbackModalUtils');
    console.log('Loaded remote module');
    newOpenFeedbackModal({
      isOpen: true,
      onClose: () => {
        console.log('close feedback modal from server');
      },
      ...(
        props ?? {}
      ),
      hideCoAuthorGenAI: !!window.wbConfig?.isEnabledFeedbackCoAuthor
    },);
  } catch (err) {
    console.error('Failed to load remote module', err);
  }
}

function loadRemoteOpenRequestedFeedbackModal(props: FeedbackModalProps) {
  try {
    // const { openRequestFeedbackModal } = await import('FEEDBACK/feedbackModalUtils');
    console.log('Loaded remote module');
    newOpenRequestFeedbackModal({
      isOpen: true,
      onClose: () => {
        console.log('close feedback modal from server');
      },
      ...(
        props ?? {}
      )
    },);
  } catch (err) {
    console.error('Failed to load remote module', err);
  }
}

const mapFeedbackLegacyObject = (props: LegacyFeedbackModalProps) => {
  const {
    memberId,
    actId,
    goalId,
    metricId
  } = props;

  if (metricId) {
    return { objectType: FeedbackObjectType.KR, objectId: metricId };
  } if (goalId) {
    return { objectType: FeedbackObjectType.Objective, objectId: goalId };
  } if (actId) {
    return { objectType: FeedbackObjectType.Action, objectId: actId };
  } if (memberId) {
    return { objectType: FeedbackObjectType.User, objectId: memberId };
  }
}

function openGiveFeedbackModal(props: LegacyFeedbackModalProps) {
  console.log('openGiveFeedbackModal', props);
  if (!window.wbConfig?.isEnabledNewFeedback) {
    return null;
  }

  console.log('openFeedbackMoal props', props);

  const feedbackObject = mapFeedbackLegacyObject(props) ?? {};
  return loadRemoteFeedbackModal({
    ...feedbackObject,
    location: props.analyticName ?? ''
  } as FeedbackModalProps);
}

function openRequestFeedbackModal(props: LegacyFeedbackModalProps) {
  console.log('openRequestedFeedbackModal', props);
  if (!window.wbConfig?.isEnabledNewFeedback) {
    return null;
  }

  console.log('openRequestedFeedbackModal props', props);
  const feedbackObject = mapFeedbackLegacyObject(props) ?? {};
  return loadRemoteOpenRequestedFeedbackModal({
    ...feedbackObject,
    location: props.analyticName ?? ''
  } as FeedbackModalProps);
}

function initFeedbackApp(elementId: string, ...props: any) {
  console.log('loadFeedbackApp');
  if (!window.wbConfig?.isEnabledNewFeedback) {
    return;
  }

  const mountParent = document.getElementById(elementId);
  if (!mountParent) {
    return;
  }
  const mount = document.createElement('div');
  mountParent.appendChild(mount);
  const root = createRoot(mount);
  root.render(<FeedbackApp {...props} />);
}

window.openGiveFeedbackModal = openGiveFeedbackModal;
window.openRequestFeedbackModal = openRequestFeedbackModal;
window.initFeedbackApp = initFeedbackApp;
